import { useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import { syncEntitlementsFromUrl } from "./entitlements";

// SCO-2495: re-run the boot-time URL → store paid-flag sync on in-app route
// changes. Mounted inside BrowserRouter above Routes (App.jsx is not mounted
// for the NoNav / Blank / Upgrade layouts). The initial search is skipped —
// index.jsx already synced it before first paint.
export default function EntitlementSync() {
  const dispatch = useDispatch();
  const { search } = useLocation();
  const booted = useRef(false);
  useEffect(() => {
    if (!booted.current) {
      booted.current = true;
      return;
    }
    syncEntitlementsFromUrl(dispatch, search);
  }, [search, dispatch]);
  return null;
}
